import React, { Component } from "react";
import user_avatar from "../../styles/img/user-avatar.jpg";
import iconPhoto from "../../styles/img/icon-photo.svg";
import iconValider from "../../styles/img/icon-check-white.svg";
import tablette1 from "../../styles/img/lenovo-tablette.jpg";
import { connect } from "react-redux";
import jwt_decode from "jwt-decode";
import {
  fetchAgent,
  updateAgent,
  updatePassword,
  getAbonnement,
  updatePhotoAgent
} from "./compte.ducks";
import Img from "react-image";
import _ from "lodash";
import { toUpperCaseFirst } from "../../ReactConst2";
import { createMuiTheme } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/styles";
import DateFnsUtils from "@date-io/moment"; // choose your lib
import moment from "moment";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import ModalOk from "./ModalMdpOk";
import { Link } from "react-router-dom";
import ModalePhoto from "../../modules/kids/kids-list/fiche-enfant/les-tabs/ModalePhoto";
import { API } from "../../const";
import { Service } from "../../modules/service/service";
import { isMobile } from "react-device-detect";
import { makeStyles } from "@material-ui/core/styles";
import srcIconPhoto from "../../styles/img/icon-photo.svg";
import UploadMobile from "../../modules/kids/kids-list/fiche-enfant/les-tabs/UploadMobile";
import emptyLogo from "../../styles/img/icon-default-logo.png";

moment.locale("fr");
const materialTheme = createMuiTheme({
  palette: {
    primary: { main: "#1d4cc5" },
  },
  overrides: {
    MuiInputBase: {
      root: {
        position: "relative",
        boxShadow: "0 0 20px rgba(0, 0, 0, 0.15)",
        borderRadius: "50px",
        border: "none",
        background: "#fff",
        outline: "none",
        padding: "0 15px",
        fontWeight: "600",
        fontSize: "18px",
        color: "#000",
      },
      input: {
        textAlign: "center",
        borderRadius: "50px",
        border: "none",
        background: "#fff",
        outline: "none !important",
        fontWeight: "normal",
        fontSize: "18px",
        color: "#000",
      },
    },
    MuiInput: {
      underline: {
        "&::before": {
          content: "none",
        },
        "&::after": {
          content: "none",
        },
      },
    },
  },
});

function toStringRole(role) {
  switch (role) {
    case "ADMIN_CRECHE":
      return "Administrateur";
    case "AGENT_CRECHE_CONFIRME":
      return "Agent confirmé";
    case "AGENT_CRECHE_NON_CONFIRME":
      return "Agent";
    default:
      return "";
  }
}
function toStringEtat(etat) {
  switch (etat) {
    case "A_CONFIRMER":
      return "Inactif";
    case "CONFIRMER":
      return "Actif";
    case "ATTENTE_PAIEMENT":
      return "Suspendu en attente de paiement";
    default:
      return "";
  }
}

const IconPhoto = () => (
  <object
    data={iconPhoto}
    type="image/svg+xml"
    className="img-fluid"
    alt="iconPhoto"
  />
);
const IconValider = () => (
  <Img src={iconValider} className="btn-valid img-fluid" alt="iconPhoto" />
);

class Compte extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dateNaissance: moment().format("YYYY-MM-DD"),
      email: "",
      nom: "",
      numeroTel: "",
      prenom: "",
      sexe: "",
      adresse: {
        codePostal: "",
        pays: "",
        rue: "",
        ville: "",
      },
      formErrors: {
        nom: "",
        prenom: "",
        numeroTel: "",
        fonction: "",
        password1: "",
        password2: "",
      },
      fullAdress: "",
      fonction: "",
      typeCompte: "",
      numeroTelValid: "",
      password1: "",
      password2: "",
      ModalePhoto: false,
      lienPhoto: "",
      photoChanged: false,
      listFormules: {
        CRECHE_MENSUEL: {
          title: "Kiuono mensuel",
          price: "98€",
          avantages: [
            "Tablette prêtée",
            "Accès illimité",
            "Aucune restriction d'utilisation",
          ],
        },
        CRECHE_ANNUEL: {
          title: "Kiuono annuel",
          price: "998€",
          avantages: [
            "Tablette offerte",
            "Accès illimité",
            "Aucune restriction d'utilisation",
            "Support et formation",
          ],
        },
      },
      fileId: "",
      croppedFile: "",
      modalUploadMobile: false,
      showPhoto: null,
    };
    this.handleChangeNaissance = this.handleChangeNaissance.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onChangeAdresse = this.onChangeAdresse.bind(this);
    this.validateFieldTel = this.validateFieldTel.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangePwd = this.handleChangePwd.bind(this);
    this.showCheckPwdConfirm = this.showCheckPwdConfirm.bind(this);
    this.closePwdConfirm = this.closePwdConfirm.bind(this);
    this.handlePwdSubmit = this.handlePwdSubmit.bind(this);
    this.showModalPhoto = this.showModalPhoto.bind(this);
    this.uploadPhoto = this.uploadPhoto.bind(this);
    this.onCloseModalePhoto = this.onCloseModalePhoto.bind(this);
    this.renderContent = this.renderContent.bind(this);
    this.onSelectFile = this.onSelectFile.bind(this);
    this.getCroppedImage = this.getCroppedImage.bind(this);
    this.uploadPhotoMobile = this.uploadPhotoMobile.bind(this);
    this.onCloseUploadMobile = this.onCloseUploadMobile.bind(this);
  }
  onCloseUploadMobile() {
    this.setState({ modalUploadMobile: false, file: "" });
  }

  uploadPhotoMobile = (e) => {
    e.preventDefault();
    let tok = localStorage.getItem("token");
    const formData = new FormData();
    formData.append("file", this.state.croppedFile);
    const response = Service.post(
      `${API}api/creche/files?category=PHOTO`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${tok}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );
    response.then((res) => {
      setTimeout(() => {}, 400);
      this.setState({
        fileId: res.data.files[0].fileId,
        lienPhoto: this.state.croppedFile,
        modalUploadMobile: false,
        photoChanged: true
      });
      this.props.updatePhotoAgent(
        localStorage.getItem("token"),
        this.props.dataCompte.id,
        this.state.fileId
      )
    });
    response.catch((err) => {
      console.log("err", err);
    });
  };
  getCroppedImage(file) {
    this.setState({ croppedFile: file });
  }
  componentDidMount() {
    let lienPhoto = this.props.dataCompte.urlPhoto
      ? this.props.dataCompte.urlPhoto
      : emptyLogo;
    this.setState({
      dateNaissance: "",
      email: "",
      nom: "",
      numeroTel: "",
      prenom: "",
      sexe: "",
      adresse: {
        codePostal: "",
        pays: "",
        rue: "",
        ville: "",
      },
      stringAdress: "",
      fonction: "",
      typeCompte: "",
      listFormules: {
        CRECHE_MENSUEL: {
          title: "Kiuono mensuel",
          price: "98€",
          avantages: [
            "Tablette prêtée",
            "Accès illimité",
            "Aucune restriction d'utilisation",
          ],
        },
        CRECHE_ANNUEL: {
          title: "Kiuono annuel",
          price: "998€",
          avantages: [
            "Tablette offerte",
            "Accès illimité",
            "Aucune restriction d'utilisation",
            "Support et formation",
          ],
        },
      },
      lienPhoto: lienPhoto,
    });
    let token = localStorage.getItem("token");
    let tokenDecoded = token ? jwt_decode(token) : "";
    if (tokenDecoded && process.env.NODE_ENV === "production") {
      this.props.fetchAgent(token, tokenDecoded.AGENT_ID);
      if (tokenDecoded.TYPE_COMPTE === "ADMIN_CRECHE") {
        this.props.getAbonnement(localStorage.getItem("token"));
      }
    }
    this.setState({ tokenDecoded });
  }
  componentDidUpdate(prevProps) {
    if (
      prevProps.dataCompte !== this.props.dataCompte &&
      !_.isEmpty(this.props.dataCompte)
    ) {
      let compte = Object.assign({}, this.props.dataCompte);

      let date = !_.isEmpty(compte.dateNaissance)
        ? compte.dateNaissance
        : moment().format("YYYY-MM-DD");
      let lienPhoto = this.props.dataCompte.urlPhoto
        ? this.props.dataCompte.urlPhoto
        : null;
      let { codePostal, pays, rue, ville } = _.isEmpty(compte.adresse)
        ? { codePostal: "", pays: "", rue: "", ville: "" }
        : compte.adresse;
      this.setState({
        dateNaissance: date,
        email: compte.email,
        nom: compte.nom,
        numeroTel: compte.numeroTel,
        prenom: compte.prenom,
        sexe: compte.sexe,
        adresse: {
          codePostal: codePostal,
          pays: pays,
          rue: rue,
          ville: ville,
        },
        lienPhoto: lienPhoto,
        fullAdress: rue + "\n" + ville + "\n" + codePostal + "\n" + pays,
        fonction: compte.fonction,
        typeCompte: compte.typeCompte,
        msgEtat: `Votre compte est ${toStringEtat(compte.etatCompte)}`,
        msgTypeCompte:
          toUpperCaseFirst(compte.prenom) +
          " " +
          toUpperCaseFirst(compte.nom) +
          ` (${toStringRole(compte.typeCompte)})`,
      });
    } else if (
      prevProps.pwdError !== this.props.pwdError &&
      _.isString(this.props.pwdError)
    ) {
      let newFormErrors = Object.assign({}, this.state.formErrors, {
        password1: this.props.pwdError,
      });
      this.setState({ formErrors: newFormErrors });
    }
  }
  renderInput = (props) => (
    <div className="form-group">
      <input
        readOnly
        className="form-control ipt-id-naissance"
        type="text"
        onClick={props.onClick}
        id={props.id}
        value={props.textLabel + props.value}
        {...props.inputProps}
      />
    </div>
  );
  handleChange = (event) => {
    let value = toUpperCaseFirst(event.target.value);
    let name = event.target.name;
    let fieldValidationErrors = Object.assign({}, this.state.formErrors, {
      [name]: "",
    });
    if (
      name === "fonction" &&
      this.props.dataCompte.typeCompte === "ADMIN_CRECHE"
    ) {
      this.setState({
        [name]: toUpperCaseFirst(event.target.value),
        formErrors: fieldValidationErrors,
      });
    } else if (name !== "fonction") {
      this.setState({ [name]: value, formErrors: fieldValidationErrors });
    }
  };
  onChangeAdresse = (event) => {
    let value = event.target.value.split(/\r?\n/);
    let newRue = value[0] ? value[0] : "";
    let newcodePOSTAL = value[1] ? value[1] : "";
    let newVille = value[2] ? value[2] : "";
    let newPays = value[3] ? value[3] : "";
    let newFullAdress =
      newRue + "\n" + newcodePOSTAL + "\n" + newVille + "\n" + newPays;
    this.setState({
      fullAdress: newFullAdress,
      adresse: {
        codePostal: newcodePOSTAL,
        pays: newPays,
        rue: newRue,
        ville: newVille,
      },
    });
  };
  handleChangeNaissance = (date) => {
    this.setState({
      dateNaissance: date,
    });
  };
  validateFieldTel(event) {
    let fieldValidationErrors = this.state.formErrors;
    // let emailValid = this.state.emailValid;
    let numeroTelValid = this.state.numeroTelValid;
    let value = event.target.value;
    let name = event.target.name;
    switch (name) {
      case "numeroTel":
        numeroTelValid = value.match(/^(\+33|0033|033|0)([0-9])[0-9]{8}$/g);
        fieldValidationErrors.numeroTel = _.isEmpty(value)
          ? "Ce champ est obligatoire"
          : numeroTelValid
          ? ""
          : "Format de télephone est invalide";
        break;
    }
    this.setState({
      numeroTel: value,
      formErrors: fieldValidationErrors,
      // emailValid: emailValid,
      numeroTelValid: numeroTelValid,
      formValid: numeroTelValid,
    });
  }
  errorClass(error) {
    return _.isEmpty(error) ? "" : "error-mess";
  }
  showModalPhoto(event) {
    event.preventDefault();
    this.setState({ ModalePhoto: true });
  }
  onCloseModalePhoto() {
    this.setState({ ModalePhoto: false });
  }
  uploadPhoto = (file) => {
    let tok = localStorage.getItem("token");
    const formData = new FormData();
    formData.append("file", file);
    const response = Service.post(
      `${API}api/creche/files?category=PHOTO`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${tok}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );
    response.then((res) => {
      this.setState({
        fileId: res.data.files[0].fileId,
        showPhoto: file,
        photoChanged: true
      });
      let token = localStorage.getItem("token");
      let tokenDecoded = token ? jwt_decode(token) : "";
      console.log("tokenDecoded", tokenDecoded);
      this.props.updatePhotoAgent(
        token,
        tokenDecoded.AGENT_ID,
        this.state.fileId
      )
    });
    response.catch((err) => {
      console.log("err", err);
    });
  };





  onSelectFile = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      let sizeInMB = (e.target.files[0].size / (1024 * 1024)).toFixed(2);
      if (sizeInMB > 5) {
        let name = "";
        let message = "Impossible d'ajouter des photos supérieur à 5 méga";
        this.props.openSnackBar(name, message);
      } else {
        const reader = new FileReader();
        reader.addEventListener("load", () =>
          this.setState({
            file: reader.result,
            isUpload: true,
            modalUploadMobile: true,
          })
        );
        reader.readAsDataURL(e.target.files[0]);
      }
    }
  };
  handleSubmit(event) {
    event.preventDefault();
    let validNom = this.state.nom ? "" : "Ce champ est obligatoire";
    let validPrenom = this.state.prenom ? "" : "Ce champ est obligatoire";
    let validFonction = this.state.fonction ? "" : "Ce champ est obligatoire";
    let validTel = !_.isEmpty(this.state.numeroTel)
      ? this.state.formErrors.numeroTel
      : "Ce champ est obligatoire";
    let formValid =
      _.isEmpty(validNom) &&
      _.isEmpty(validPrenom) &&
      _.isEmpty(validFonction) &&
      _.isEmpty(validTel);
    this.setState({
      formErrors: {
        nom: validNom,
        prenom: validPrenom,
        numeroTel: validTel,
        fonction: validFonction,
      },
    });
    if (formValid) {
      let data = {
        dateNaissance: moment(this.state.dateNaissance).format("YYYY-MM-DD"),
        email: this.state.email,
        fonction: this.state.fonction,
        nom: this.state.nom,
        numeroTel: this.state.numeroTel,
        prenom: this.state.prenom,
        sexe: "MALE",
        adresse: this.state.adresse,
        typeCompte: this.state.typeCompte,
      };
      this.props.updateAgent(
        localStorage.getItem("token"),
        this.props.dataCompte.id,
        data
      );
    }
  }

  handleChangePwd(event) {
    let value = event.target.value;
    let name = event.target.name;
    let fieldValidationErrors = Object.assign({}, this.state.formErrors, {
      [name]: "",
    });
    this.setState({ [name]: value, formErrors: fieldValidationErrors });
  }
  showCheckPwdConfirm() {
    let password1Error =
      this.state.password1 &&
      this.state.password2 &&
      this.state.password2 === this.state.password1
        ? ""
        : this.state.password1 &&
          this.state.password2 &&
          this.state.password2 !== this.state.password1
        ? "Les deux champs doivent être identiques"
        : this.state.password1
        ? ""
        : "Champs vide";
    let password2Error = this.state.password2 ? "" : "Champs vide";
    let fieldValidationErrors = Object.assign({}, this.state.formErrors, {
      password1: password1Error,
      password2: password2Error,
    });

    let openModal = _.isEmpty(password1Error) && _.isEmpty(password2Error);
    this.setState({ formErrors: fieldValidationErrors, openMdpOk: openModal });
  }
  closePwdConfirm() {
    this.setState({ openMdpOk: false });
  }
  handlePwdSubmit() {
    let data = {
      confirmPassword: this.state.password2,
      password: this.state.password1,
    };
    this.props.updatePassword(localStorage.getItem("token"), data);
    this.closePwdConfirm();
  }
  renderContent = () => {
    const classes = makeStyles((theme) => ({
      root: {
        "& > *": {
          margin: theme.spacing(1),
        },
      },
      input: {
        display: "none",
      },
    }));
    if (isMobile) {
      return (
        <div className={classes.root}>
          <input
            className={classes.input}
            id="contained-button-file"
            type="file"
            style={{ display: "none" }}
            onChange={this.onSelectFile}
            accept="image/png,image/bmp,image/jpeg"
          />

          <div className="input-file-style mr-3">
            <label
              htmlFor="contained-button-file"
              className="btn-photo btn-gradient"
            >
              <img src={srcIconPhoto} className="img-fluid" alt="" />{" "}
            </label>
          </div>
        </div>
      );
    }
    return (
      <button
        type="button"
        className="btn-photo btn-gradient"
        data-toggle="modal"
        data-target="#modalPhoto"
        onClick={(e) => this.showModalPhoto(e)}
      >
        <img src={srcIconPhoto} className="img-fluid" alt="" />
      </button>
    );
  };

  render() {
     var divStyle = (lienPhoto) => ({
      backgroundImage: "url(" + lienPhoto + ")",
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
    });
    let match = this.props.match;
    return (
      <div className="main-wrapper fiche-enfant">
        <div className="banner d-flex justify-content-center">
          <Link to="/enfants" className="back-link">
            Retour
          </Link>
          <div className="content">
            <div className="selected-child d-flex align-items-center">
              <div
                className="avatar-fiche"
                style={
                  _.isEmpty(this.state.showPhoto)
                    ? divStyle(this.state.lienPhoto)
                    : divStyle(window.URL.createObjectURL(this.state.showPhoto))
                }
              ></div>
              <h1>
                {`${this.state.msgTypeCompte}`}
                <small>{`${this.state.msgEtat}`}</small>
              </h1>
            </div>
          </div>
        </div>
        <section className="content-fiche">
          <div className="tab-content p-0" id="myTabContent">
            <div
              className="tab-pane fade active show"
              id="identite-pane"
              role="tabpanel"
              aria-labelledby="identite-tab"
            >
              <div className="content p-0">
                <p className="small-bottom-space"></p>
                <form>
                  <section className="content-section">
                    <h2>Informations de contact</h2>
                    <div className="row">
                      <div className="col-md-5">
                        <div
                          className={`form-group ${this.errorClass(
                            this.state.formErrors[`prenom`]
                          )}`}
                        >
                          <input
                            type="text"
                            className="form-control ipt-id-nom"
                            name="prenom"
                            placeholder="Prénom"
                            onChange={this.handleChange}
                            value={this.state.prenom}
                          />
                          {(() => {
                            if (!_.isEmpty(this.state.formErrors["prenom"])) {
                              return <p>{this.state.formErrors["prenom"]}</p>;
                            } else {
                              return "";
                            }
                          })()}
                        </div>
                        <div className="form-group">
                          <input
                            type="email"
                            className="form-control ipt-id-email"
                            name="email"
                            onChange={this.handleChange}
                            placeholder="Email"
                            value={this.state.email}
                          />
                        </div>
                        <div className="form-group">
                          <ThemeProvider theme={materialTheme}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <DatePicker
                                autoOk
                                ampm={false}
                                value={this.state.dateNaissance}
                                onChange={this.handleChangeNaissance}
                                format={" DD-MM-YYYY"}
                                TextFieldComponent={this.renderInput}
                                textLabel="Né le"
                              />
                            </MuiPickersUtilsProvider>
                          </ThemeProvider>
                        </div>
                        <div
                          className={`form-group ${this.errorClass(
                            this.state.formErrors[`fonction`]
                          )}`}
                        >
                          <input
                            type="text"
                            className="form-control ipt-id-nom"
                            name="fonction"
                            placeholder="Fonction"
                            onChange={this.handleChange}
                            value={this.state.fonction}
                          />
                          {(() => {
                            if (!_.isEmpty(this.state.formErrors["fonction"])) {
                              return <p>{this.state.formErrors["fonction"]}</p>;
                            } else {
                              return "";
                            }
                          })()}
                        </div>
                      </div>
                      <div className="col-md-5">
                        <div
                          className={`form-group ${this.errorClass(
                            this.state.formErrors[`nom`]
                          )}`}
                        >
                          <input
                            type="text"
                            className="form-control ipt-id-nom"
                            name="nom"
                            placeholder="Nom"
                            onChange={this.handleChange}
                            value={this.state.nom}
                          />
                          {(() => {
                            if (!_.isEmpty(this.state.formErrors["nom"])) {
                              return <p>{this.state.formErrors["nom"]}</p>;
                            } else {
                              return "";
                            }
                          })()}
                        </div>
                        <div
                          className={`form-group ${this.errorClass(
                            this.state.formErrors[`numeroTel`]
                          )}`}
                        >
                          <input
                            type="tel"
                            className="form-control ipt-id-tel"
                            placeholder="Téléphone"
                            onChange={this.validateFieldTel}
                            name="numeroTel"
                            value={this.state.numeroTel}
                          />
                          {(() => {
                            if (
                              !_.isEmpty(this.state.formErrors["numeroTel"])
                            ) {
                              return (
                                <p>{this.state.formErrors["numeroTel"]}</p>
                              );
                            } else {
                              return "";
                            }
                          })()}
                        </div>
                        <div
                          className={`form-group ${this.errorClass(
                            this.state.formErrors[`adresse`]
                          )}`}
                        >
                          <textarea
                            className="form-control ipt-id-adress"
                            name="adresse"
                            placeholder="Adresse de facturation"
                            onChange={this.onChangeAdresse}
                            value={this.state.fullAdress}
                          >
                            {(() => {
                              if (
                                !_.isEmpty(this.state.formErrors["adresse"])
                              ) {
                                return (
                                  <p>{this.state.formErrors["adresse"]}</p>
                                );
                              } else {
                                return "";
                              }
                            })()}
                          </textarea>
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div
                          className="photo-enfant"
                          style={
                            _.isEmpty(this.state.showPhoto)
                              ? divStyle(this.state.lienPhoto)
                              : divStyle(
                                  window.URL.createObjectURL(
                                    this.state.showPhoto
                                  )
                                )
                          }
                        >
                          {this.renderContent()}
                        </div>
                      </div>
                    </div>
                  </section>
                  {this.props.dataCompte && (
                    <section className="content-section">
                      <h2>Mes sections</h2>
                      <div className="row">
                        <div className="col-md-10">
                          {this.props.dataCompte.accesToutesLesSections ? (
                            <span style={{
                              backgroundColor: "#4CAF50",
                              color: "#fff",
                              padding: "6px 16px",
                              borderRadius: "20px",
                              fontSize: "13px",
                              fontWeight: "500",
                            }}>Accès à toutes les sections</span>
                          ) : this.props.dataCompte.sections && this.props.dataCompte.sections.length > 0 ? (
                            <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                              {this.props.dataCompte.sections.map((s, idx) => (
                                <span key={idx} style={{
                                  backgroundColor: s.couleur || "#999",
                                  color: "#fff",
                                  padding: "6px 16px",
                                  borderRadius: "20px",
                                  fontSize: "13px",
                                  fontWeight: "500",
                                }}>{s.nom}</span>
                              ))}
                            </div>
                          ) : (
                            <span style={{ fontSize: "13px", color: "#999", fontStyle: "italic" }}>
                              Aucune section assignée — accès à tous les enfants
                            </span>
                          )}
                        </div>
                      </div>
                    </section>
                  )}
                  <section className="content-section">
                    <div className="d-flex justify-content-center">
                      <button
                        type="button"
                        className="btn-gradient btn-valid"
                        onClick={this.handleSubmit}
                      >
                        <IconValider />
                        Valider
                      </button>
                    </div>
                  </section>
                </form>

                <section className="content-section">
                  <h2>Modifier votre mot de passe</h2>
                  <div className="row">
                    <div className="col-md-5">
                      <div
                        className={`form-group ${this.errorClass(
                          this.state.formErrors[`password1`]
                        )}`}
                      >
                        <input
                          type="password"
                          name="password1"
                          className="form-control"
                          id="ipt-password1"
                          value={this.state.password1}
                          onChange={this.handleChangePwd}
                          placeholder="Nouveau mot de passe"
                        />
                        {(() => {
                          if (!_.isEmpty(this.state.formErrors["password1"])) {
                            return <p>{this.state.formErrors["password1"]}</p>;
                          } else {
                            return "";
                          }
                        })()}
                      </div>
                    </div>
                    <div className="col-md-5">
                      <div
                        className={`form-group ${this.errorClass(
                          this.state.formErrors[`password2`]
                        )}`}
                      >
                        <input
                          type="password"
                          name="password2"
                          className="form-control"
                          id="ipt-password2"
                          value={this.state.password2}
                          onChange={this.handleChangePwd}
                          placeholder="Confirmer mot de passe"
                        />
                        {(() => {
                          if (!_.isEmpty(this.state.formErrors["password2"])) {
                            return <p>{this.state.formErrors["password2"]}</p>;
                          } else {
                            return "";
                          }
                        })()}
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="d-flex justify-content-center">
                        <button
                          type="button"
                          className="btn-gradient btn-confirm"
                          onClick={this.showCheckPwdConfirm}
                          data-toggle="modal"
                          data-target="#modalMdpOk"
                        >
                          Modifier
                        </button>
                      </div>
                    </div>
                  </div>
                </section>

                {this.state.openMdpOk ? (
                  <ModalOk
                    title={"Changement de mot de passe"}
                    message={
                      "Après la modification de votre mot de passe vous serez automatiquement déconnecté de l'application."
                    }
                    closeModal={this.closePwdConfirm}
                    handleSubmit={this.handlePwdSubmit}
                  />
                ) : (
                  ""
                )}

                {!_.isEmpty(this.props.dataCompte) &&
                !_.isEmpty(this.props.abonnement) &&
                this.props.dataCompte.typeCompte === "ADMIN_CRECHE" ? (
                  <section className="content-section">
                    {(() => {
                      let abonnement = this.props.abonnement;
                      let listFormules = this.state.listFormules;
                      let typeAbonToString =
                        abonnement.type === "CRECHE_MENSUEL"
                          ? "Mensuel"
                          : "Annuel";
                      let formule1 = abonnement.type;
                      let formule2 =
                        abonnement.type === "CRECHE_MENSUEL"
                          ? "CRECHE_ANNUEL"
                          : "CRECHE_MENSUEL";
                      return (
                        <>
                          <h2>Votre abonnement ({typeAbonToString})</h2>
                          <div className="d-flex justify-content-center">
                            <h5>
                              Prochaine échéance le{" "}
                              {moment(abonnement.dateEcheance).format(
                                "DD MMMM YYYY"
                              )}
                            </h5>
                          </div>
                          <div
                            className="row align-items-center row-formules"
                            style={{ flexWrap: "unset" }}
                          >
                            <div className="col-lg-6">
                              <div className="bande-formule formule1">
                                <div className="title">
                                  {listFormules[formule1].title}
                                </div>
                                <div className="price">
                                  {listFormules[formule1].price}{" "}
                                  <small>HT / an</small>
                                </div>
                                <ul className="list-avantages">
                                  {listFormules[formule1].avantages.map(
                                    (element, index) => (
                                      <li key={index}>{element}</li>
                                    )
                                  )}
                                </ul>
                                <div className="d-flex justify-content-center">
                                  <a
                                    target="_blank"
                                    href={abonnement.urlAbonnement}
                                    className="btn-formule txt-black"
                                  >
                                    Gérer votre abonnement
                                  </a>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="bande-formule formule2">
                                <div className="title">
                                  {listFormules[formule2].title}
                                </div>
                                <div className="price">
                                  {listFormules[formule2].price}{" "}
                                  <small>HT / mois</small>
                                </div>
                                <ul className="list-avantages">
                                  {listFormules[formule2].avantages.map(
                                    (element, index) => (
                                      <li key={index}>{element}</li>
                                    )
                                  )}
                                </ul>
                                <div className="d-flex justify-content-center">
                                  <a
                                    target="_blank"
                                    href={abonnement.urlAbonnement}
                                    className="btn-formule txt-black"
                                  >
                                    Changer pour cette formule
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      );
                    })()}
                  </section>
                ) : (
                  ""
                )}
                {this.props.abonnement.equipementFourni ? (
                  <section className="content-section">
                    {Array.from(this.props.abonnement.equipements).map(
                      (element) => {
                        return (
                          <>
                            <h2>
                              Matériel mis à disposition (ref#
                              {element.reference})
                            </h2>
                            <div className="row align-items-stretch">
                              <div
                                className="col-md-7"
                                style={{ textAlign: "justify" }}
                              >
                                <div className="form-group">
                                  <img
                                    src={element.urlPhoto}
                                    className="img-fluid"
                                    alt=""
                                  />
                                </div>
                              </div>
                              <div className="col-md-5">
                                {element.description}
                              </div>
                            </div>
                          </>
                        );
                      }
                    )}
                  </section>
                ) : (
                  ""
                )}
                {this.state.ModalePhoto ? (
                  <ModalePhoto
                    onCloseModalePhoto={this.onCloseModalePhoto}
                    ModalePhoto={this.state.ModalePhoto}
                    uploadPhoto={this.uploadPhoto}
                    photo={this.state.lienPhoto}
                  />
                ) : (
                  ""
                )}
                {this.state.modalUploadMobile ? (
                  <UploadMobile
                    photo={this.state.file}
                    onCloseUploadMobile={this.onCloseUploadMobile}
                    getCroppedImage={this.getCroppedImage}
                    uploadPhotoMobile={this.uploadPhotoMobile}
                  />
                ) : null}
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  dataCompte: state.compte.data,
  pwdError: state.compte.pwdError,
  abonnement: state.compte.abonnement,
});
export default connect(mapStateToProps, {
  fetchAgent,
  updateAgent,
  updatePassword,
  getAbonnement,
  updatePhotoAgent
})(Compte);
